import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import VehicleManagement from './VehicleManagement';
import RouteManagement from './RouteManagement';
import DriverManagement from './DriverManagement';
import StudentTransport from './StudentTransport';
import TransportFees from './TransportFees';
import StudentRouteAssignment from './StudentRouteAssignment';

interface TransportModuleProps {
  domain: string;
  onBack: () => void;
}

const TransportModule: React.FC<TransportModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('vehicles');

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/route-map')) setActiveTab('route-map');
    else if (path.includes('/routes')) setActiveTab('routes');
    else if (path.includes('/drivers')) setActiveTab('drivers');
    else if (path.includes('/students')) setActiveTab('students');
    else if (path.includes('/fees')) setActiveTab('fees');
    else setActiveTab('vehicles');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-bus-front me-2"></i>Transport Management
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'vehicles' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport')}
              >
                <i className="bi bi-truck me-2"></i>Vehicles
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'routes' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport/routes')}
              >
                <i className="bi bi-map me-2"></i>Routes
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'drivers' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport/drivers')}
              >
                <i className="bi bi-person-badge me-2"></i>Drivers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'students' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport/students')}
              >
                <i className="bi bi-people me-2"></i>Student Transport
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'fees' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport/fees')}
              >
                <i className="bi bi-currency-dollar me-2"></i>Transport Fees
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'route-map' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/transport/route-map')}
              >
                <i className="bi bi-geo-alt me-2"></i>Route Map
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<VehicleManagement domain={domain} />} />
          <Route path="routes" element={<RouteManagement domain={domain} />} />
          <Route path="drivers" element={<DriverManagement domain={domain} />} />
          <Route path="students" element={<StudentTransport domain={domain} />} />
          <Route path="fees" element={<TransportFees domain={domain} />} />
          <Route path="route-map" element={<StudentRouteAssignment domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default TransportModule;
